import {cloneElement, useRef, useState} from 'react'
import {ModalManagerContext} from './ModalManagerContext.mjs'

export default function ModalManager({children}) {
    const [modals, setModals] = useState([])
    const refCtx = useRef()

    if (! refCtx.current) {
        refCtx.current = (modal, options) => {
            const {promise, resolve} = Promise.withResolvers()
            const key = crypto.randomUUID()

            const afterClose = () => {
                setModals(modals => modals.filter(m => m.key !== key))
            }

            const close = () => {
                setModals(modals => modals.map(
                    m => {
                        if (m.key === key) {
                            return clone(m, {open: false, visible: false})
                        }
                        else {
                            return m
                        }
                    })
                )
            }

            const onCancel = () => {
                close()
                resolve()
            }

            const onOk = result => {
                close()
                resolve(result)
            }

            const clone = (e, modalProps) => {
                const _clone = (e, modalProps) => {
                    if (
                        Symbol.for('react.context') === e.type.$$typeof ||
                        Symbol.for('react.provider') === e.type.$$typeof
                    ) {
                        return cloneElement(e, {
                            children: _clone(e.props.children, modalProps)
                        })
                    }
                    else {
                        return cloneElement(e, {
                            afterClose,
                            destroyOnClose: true,
                            onCancel,
                            onOk,
                            ...modalProps,
                        })
                    }
                }

                return cloneElement(_clone(e, modalProps), {key})
            }

            const m = (
                <ModalManagerContext.Provider value={refCtx.current}>
                    {modal}
                </ModalManagerContext.Provider>
            )

            if (options?.signal) {
                options.signal.addEventListener('abort', onCancel, {once: true})
            }

            setModals(modals => [
                ...modals,
                clone(m, {open: true, visible: true})
            ])

            return promise
        }
    }

    return (
        <>
            <ModalManagerContext.Provider value={refCtx.current}>
                {children}
            </ModalManagerContext.Provider>

            {modals}
        </>
    )
}
